module.exports = __webpack_public_path__ + "img/logoEstudioAppBlanco.4d6330eb.svg";